import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';

const InstructionsModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <motion.div
            className="bg-white rounded-3xl p-8 max-w-lg w-full shadow-2xl relative"
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.8, opacity: 0 }}
            transition={{ type: "spring", stiffness: 100, damping: 15 }}
          >
            <button
              onClick={onClose}
              className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors duration-200"
            >
              <X className="w-6 h-6" />
            </button>
            <h2 className="text-3xl font-bold text-gray-800 mb-6 text-center">Cómo Usar WHERE?</h2>
            <div className="space-y-4 text-gray-700">
              <p>¡Felicidades, has encontrado el botón de ayuda! Aquí te explico cómo sacarle el jugo a esta maravilla tecnológica:</p>
              <ol className="list-decimal list-inside space-y-2">
                <li>
                  <strong>Obtener Ubicación:</strong> Pulsa el gran botón "Obtener Ubicación". Tu dispositivo intentará encontrar dónde estás. Si te pide permiso, ¡dáselo! No somos espías, solo curiosos.
                </li>
                <li>
                  <strong>Ver Coordenadas:</strong> Una vez obtenida, verás tu ubicación mágica (X, Y, Z), de dónde la sacamos (GPS o Antena) y con qué precisión. ¡Todo en una tabla bonita!
                </li>
                <li>
                  <strong>Sistemas de Coordenadas:</strong> Hemos añadido un toque de sofisticación con diferentes sistemas de coordenadas. Porque no todo es WGS84, ¿verdad?
                </li>
                <li>
                  <strong>Eliminar Registros:</strong> ¿Te arrepentiste de una ubicación? No hay problema, pulsa el icono de la papelera al lado del registro y ¡adiós!
                </li>
                <li>
                  <strong>Exportar a CSV:</strong> ¿Quieres llevarte tus datos a otro lado? El botón "Exportar CSV" te generará un archivo con todas tus ubicaciones. ¡Ideal para tus informes secretos!
                </li>
                <li>
                  <strong>Limpiar Todo:</strong> Si quieres empezar de cero, el botón "Limpiar Todo" borrará todos los registros de la tabla. ¡Un borrón y cuenta nueva!
                </li>
                <li>
                  <strong>Título Mágico:</strong> Si pulsas el título "WHERE?", te llevará a una web fascinante. ¡No te lo pierdas!
                </li>
              </ol>
              <p className="text-center mt-6 text-sm text-gray-500">
                ¡Ahora ve y conquista el mundo con tus coordenadas!
              </p>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default InstructionsModal;